import React from 'react';
import Select from 'react-select';

const CustomSelect = ({
  options,
  defaultOption,
  isDisabled,
  isLoading,
  isRtl,
  isSearchable,
  name,
  value,
  onChange,
  bgColor = "white",
	borderColor = "#cccccc",
  className = "basic-select",
  mode2
}) => {
  const customStyles = {
    container: (provided) => ({
      ...provided,
      width:  (window.innerWidth <= 1500) || (mode2 === '24') ? '140px' : '180px',
      color: 'white'
    }),
    control: (provided) => ({
      ...provided,
      borderRadius: '8px',
      padding: '0px 4px',
      boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)',
      backgroundColor: bgColor,
      borderColor: borderColor,
    }),
    singleValue: (provided) => ({
      ...provided,
      fontSize: (window.innerWidth <= 1500) || (mode2 === '24') ? '12px' : '14px', 
    }),
    indicatorSeparator: () => ({
      display: 'none',
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: 'gray',
      padding: '2px', 
      width: '20px', 
      height: '20px', 
      minWidth: '20px', 
      minHeight: '20px',
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 1050,
      boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.3)'
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 1050,
    }),
  };


  const handleMouseDown = (e) => { e.stopPropagation(); };
  const handleKeyDown = (e) => { e.stopPropagation(); };

  return (
    <Select
      className={className}
      classNamePrefix="select"
      defaultValue={defaultOption}
      value={value}
      isDisabled={isDisabled}
      isLoading={isLoading}
      isRtl={isRtl}
      isSearchable={isSearchable}
      name={name}
      options={options}
      onChange={onChange}
      styles={customStyles}
      menuPortalTarget={document.body}
      menuPlacement="auto"
      menuPosition="fixed"
      onMouseDown={handleMouseDown}
      onKeyDown={handleKeyDown}
    />
  );
};

export default CustomSelect;
